import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import PageLoader from "@components/Loader/Loader";
import { useAuthContext } from "state/context/AuthContext";

type ProtectedRouteProps = {
  children: ReactNode;
};

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const {
    state: { isAuthenticated, status },
  } = useAuthContext();

  if (status === "loading") {
    return <PageLoader />;
  }

  if (isAuthenticated || status === "authenticated") {
    return <>{children}</>;
  }

  return <Navigate to="/login" replace />;
};

export default ProtectedRoute;
